import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {GlobalService} from '../../../global.service';
import {MatPaginator, MatTableDataSource} from '@angular/material';
import {boolean} from 'smooth-scrollbar/decorators';
import {AuthenticationService} from '../../../authentication.service';
import {EventsService} from '../../events/events.service';
import {SeasonsService} from '../seasons.service';

@Component({
  selector: 'elastic-standings',
  templateUrl: './standings.component.html',
  styleUrls: ['./standings.component.scss']
})
export class StandingsComponent implements OnInit, AfterViewInit {

  @Input() event: any;

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();

  dataSource: MatTableDataSource<any>;
  dataSource2: MatTableDataSource<any>;
  dataSource3: MatTableDataSource<any>;
  dataSource4: MatTableDataSource<any>;
  dataSource5: MatTableDataSource<any>;

  list1 = [];
  list2 = [];
  list3 = [];
  list4 = [];
  myPos = 0;
  myDiv = 0;

  constructor(private globalService: GlobalService, private auth: AuthenticationService, private seasonsService: SeasonsService, private cdr: ChangeDetectorRef) { }

  ngOnInit() {







  }


  ngAfterViewInit() {

    this.seasonsService.getEventStandings(this.event.event_id).subscribe( (data: any) => {
      if (data) {
        this.event.standings = data;
        if (this.event.standings[0].division !== undefined) {
          let pos1 = 1;
          let pos2 = 1;
          let pos3 = 1;
          let pos4 = 1;

          this.event.standings.forEach((item) => {

            if (item.division == 1) {
              item.position = pos1;
              this.list1.push(item);
              pos1 = pos1 + 1;
            }

            if (item.division == 2) {
              item.position = pos2;
              this.list2.push(item);
              pos2 = pos2 + 1;
            }

            if (item.division == 3) {
              item.position = pos3;
              this.list3.push(item);
              pos3 = pos3 + 1;
            }

            if (item.division == 4) {
              item.position = pos4;
              this.list4.push(item);
              pos4 = pos4 + 1;
            }

          });

        } else {
          this.dataSource = new MatTableDataSource<any>(this.event.standings);
        }

      }

      this.seasonsService.getEventTeamStandings(this.event.event_id).subscribe((data2: any) => {
        if (data2) {
          this.event.team_standings = data2;
          this.dataSource5 = new MatTableDataSource<any>(this.event.team_standings);
          this.myPos = this.findMyPos(this.event.standings);
          this.myDiv = this.findMyDiv(this.event.standings);
          this.cdr.detectChanges();
        }

        this.dataSource = new MatTableDataSource<any>(this.list1);
        this.dataSource2 = new MatTableDataSource<any>(this.list2);
        this.dataSource3 = new MatTableDataSource<any>(this.list3);
        this.dataSource4 = new MatTableDataSource<any>(this.list4);
        this.dataSource.paginator   = this.paginator.toArray()[0];
        this.dataSource2.paginator  = this.paginator.toArray()[1];
        this.dataSource3.paginator  = this.paginator.toArray()[2];
        this.dataSource4.paginator  = this.paginator.toArray()[3];
        this.dataSource5.paginator  = this.paginator.toArray()[4];

      });

    });

    //this.dataSource.paginator   = this.paginator.toArray()[0];
    //this.dataSource2.paginator  = this.paginator.toArray()[1];
    //this.dataSource3.paginator  = this.paginator.toArray()[2];
    //this.dataSource4.paginator  = this.paginator.toArray()[3];
    //this.dataSource5.paginator  = this.paginator.toArray()[4];

    //this.myPos = this.findMyPos(this.event.standings);
    //this.myDiv = this.findMyDiv(this.event.standings);
  }

  findMyPos(standings) {
    let position = 0;
    standings.forEach((item)=> {
        if (item.user_id == this.auth.getUserId()) {
          position = item.position;
        }
    });
    return position;
  }

  findMyDiv(standings) {
    let position = 0;
    standings.forEach((item)=> {
      if (item.user_id == this.auth.getUserId()) {
        position = item.division;
      }
    });
    return position;
  }

}
